<template>
  <div id="app">
    <cart/>
    <app-header/>
    <router-view/>
    <app-footer/>
    
  </div>
</template>

<script>
  import Cart from './components/Cart';
  import Header from './components/Header';
  import Footer from './components/Footer';

  export default {
    name: 'app',
    components: {
      cart: Cart,
      'app-header': Header,
      'app-footer': Footer,
    },

    data: function() {
      return {
        paypalScript: '',
      }
    },

    mounted() {
      this.paypalScript = document.createElement('script');
      this.paypalScript.setAttribute('src', 'https://www.paypalobjects.com/api/checkout.js');
      document.head.appendChild(this.paypalScript);
    },
  }
</script>

<style>
  #app {

  }
</style>
